/* import __COLOCATED_TEMPLATE__ from './promo-opt-out.hbs'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from '@ember/object';
import { later } from '@ember/runloop';
import Component from '@glimmer/component';
let TwoFactorModalPromoOptOutComponent = (_class = class TwoFactorModalPromoOptOutComponent extends Component {
  constructor() {
    super(...arguments);
  }
  close() {
    // Close modal using later to ensure page click fires before modal close
    later(this, () => {
      this.args.close();
    });
  }
}, _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _class);
export { TwoFactorModalPromoOptOutComponent as default };